module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [(_vm.message) ? _c('div', {
    class: 'ui ' + (_vm.error ? 'negative' : 'positive') + ' message'
  }, [_vm._v(_vm._s(_vm.message))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("\n  Step #1:     "), _c('div', {
    staticClass: "ui labeled icon button",
    on: {
      "click": _vm.exportExcel
    }
  }, [_c('i', {
    staticClass: "download icon"
  }), _vm._v("Download " + _vm._s(_vm.watchDogName) + " Alert Settings")]), _vm._v(" "), _c('br'), _c('br'), _vm._v("\n\n  Step #2:     Edit your settings in bulk in the Spreadsheet\n  "), _c('br'), _c('br'), _vm._v("\n\n  Step #3:     \n  "), _c('span', [_c('label', {
    staticClass: "ui labeled icon button",
    attrs: {
      "for": 'hidden-' + _vm.apiPrefix + '-config-import-file'
    },
    on: {
      "click": _vm.resetFiles
    }
  }, [_c('i', {
    staticClass: "upload icon"
  }), _vm._v("Upload " + _vm._s(_vm.watchDogName) + " Alert Settings\n    ")]), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": 'hidden-' + _vm.apiPrefix + '-config-import-file'
    },
    on: {
      "change": _vm.importExcel
    }
  })]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('button', {
    staticClass: "ui tiny compact button",
    on: {
      "click": function($event) {
        _vm.$parent.showConfiguration = false
      }
    }
  }, [_c('i', {
    staticClass: "left chevron icon"
  }), _vm._v("\n    Back \n  ")]), _vm._v(" "), _c('br'), _vm._v("  \n  \n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52fe5a5e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/SpreadsheetConfig.vue
// module id = 775
// module chunks = 2